export default {
  "b2b.projekty-grid.add": "Přidat projekt",
  "b2b.projekty-grid.title": "Projekty",
  "b2b.projekty-grid.delete-dialog.title": "Smazání projektu",
  "b2b.projekty-grid.delete-dialog.confirm": "Opravdu chcete smazat projekt?"
};
